export const CONTACT_SUPPORT_LABEL = 'Contact support';
export const CONTACT_SUPPORT_LOWERCASE_LABEL = 'contact support';
